(function () {
    var psptmpl = function () {
        return [

            // Email
            {
                type: 'output',
                regex: 'email=(.*)',
                replace: function (match, prefix, content) {
                    return '<p><span class="email"></span>&nbsp;<small>' + prefix + '</small></p>';
                }
            },
            {
                type: 'output',
                regex: 'EMAIL=(.*)',
                replace: function (match, prefix, content) {
                    return '<p><span class="center"><span class="email"></span>&nbsp;<small>' + prefix + '</small></span></p>';
                }
            },

            // Phone
            {
                type: 'output',
                regex: 'phone=(.*)',
                replace: function (match, prefix, content) {
                    return '<p><span class="phone"></span>;&nbsp;<small>' + prefix + '</small></p>';
                }
            },            
            {
                type: 'output',
                regex: 'PHONE=(.*)',
                replace: function (match, prefix, content) {
                    return '<p><span class="center"><span class="phone"></span>&nbsp;<small>' + prefix + '</small></span></p>';
                }
            },

            // Calendar
            {
                type: 'output',
                regex: '\<calendar(.*)\>',
                replace: function (match, prefix, content) {
                    var month = prefix.match(/month="([^"]*)/g);
                    month = month[0].replace(/month="/g, "");

                    var day = prefix.match(/day="([^"]*)/g);
                    day = day[0].replace(/day="/g, "");

                    var tmpl = $("#preview-calendar").html();
                    tmpl = tmpl.replace('{{month}}', month);
                    tmpl = tmpl.replace('{{day}}', day);

                    return tmpl;
                }
            },

            // Content
            {
                type: 'output',
                filter: function (text) {

                    text = text.replace(/\<content\>/gim, function () {
                        return '<td class="wrapper"><table class="nine columns"><tr><td>';
                    });

                    text = text.replace(/\<\/content\>/gim, function () {
                        return '</td><td class="expander"></td></tr></table></td>';
                    });

                    return text;
                }
            },

            // Sidebar
            {
                type: 'output',
                filter: function (text) {

                    text = text.replace(/\<sidebar\>/gim, function () {
                        return '<td class="wrapper last"><table class="three columns"><tr><td class="center"><center>';
                    });

                    text = text.replace(/\<\/sidebar\>/gim, function () {
                        return '</center></td><td class="expander"></td></tr></table></td>';
                    });

                    return text;
                }
            },

            // Buttons
            {
                type: 'output',
                regex: '\<button-green\>',
                replace: function (match, prefix, content) {
                    return '<table class="button success radius"><tr><td>';
                }
            }, 
            {
                type: 'output',
                regex: '<\/button-green\>',
                replace: function (match, prefix, content) {
                    return '</td></tr></table>';
                }
            },  
            {
                type: 'output',
                regex: '\<button-blue\>',
                replace: function (match, prefix, content) {
                    return '<table class="button radius"><tr><td>';
                }
            },
            {
                type: 'output',
                regex: '<\/button-blue\>',
                replace: function (match, prefix, content) {
                    return '</td></tr></table>';
                }
            },

            // Center
            {
                type: 'output',
                filter: function (text) {

                    text = text.replace(/-->([^&]*)&lt;--/gim, function (x, y) {
                        return '<center class="uppercase">' + y + '</center>';
                    });

                    text = text.replace(/->([^&]*)&lt;-/gim, function (x, y) {
                        return '<center>' + y + '</center>';
                    });

                    return text;
                }
            },

            // Placeholder
            {
                type: 'output',
                filter: function (text) {

                    text = text.replace(/\{\@\([^\)]*\)\:[^\}]*\}/gim, function (expressMatch, position) {
                        var razor = expressMatch.match(/\{\@\(([^\)]*)\)/g);
                        razor = razor[0].substring(1);

                        var defaultValue = expressMatch.match(/\:([^\}]*)\}/g);
                        defaultValue = defaultValue[0].substring(1);
                        defaultValue = defaultValue.substring(0, defaultValue.length-1);

                        return '<span razor="' + razor + '">' + defaultValue + '</span>';
                    });

                    return text;
                }
            },
        ];
    };

    // Client-side export
    if (typeof window !== 'undefined' && window.Showdown && window.Showdown.extensions) {
        window.Showdown.extensions.psptmpl = psptmpl;
    }
    // Server-side export
    if (typeof module !== 'undefined') {
        module.exports = psptmpl;
    }
}());
